/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabrielecavallo
 * File: CompanySelect.tsx
 * Project: mle-client-n
 * Committed last: 2022/9/22 @ 181
 * ---
 * Description:
 */

import {MyLabelCompanyMeta} from '../../../../entities';
import {ItemRenderer, Select} from '@blueprintjs/select';
import {Button, MenuItem} from '@blueprintjs/core';
import {useCallback, useState} from 'react';

interface Props {
    companies: MyLabelCompanyMeta[];
    onChange: (company: MyLabelCompanyMeta) => void;
    initialValue?: MyLabelCompanyMeta;
    isLoading: boolean;
}

const CSelect = Select.ofType<MyLabelCompanyMeta>();

export const CompanySelect = (props: Props) => {
  const [selectedCompany, setSelectedCompany] = useState<MyLabelCompanyMeta | undefined>(
    props.initialValue);

  const companyItemRenderer: ItemRenderer<MyLabelCompanyMeta> = (item, {
    handleClick,
    index
  }) => {
    return (
      <MenuItem text={ item.name } key={ item.id }
                onClick={ handleClick }/>
    );
  };

  const getTextValue = useCallback(() => {
    if (selectedCompany) return selectedCompany.name;

    if (props.initialValue) return props.initialValue.name;
    return 'Seleziona un\'organizzazione';
  }, [selectedCompany, props.initialValue]);

  return (
    <CSelect itemRenderer={ companyItemRenderer } items={ props.companies }
             onItemSelect={ item => {
               setSelectedCompany(item);
               props.onChange(item);
             } } filterable={ false }>
      <Button rightIcon="caret-down" loading={ props.isLoading }>
        {
          getTextValue()
        }
      </Button>
    </CSelect>
  );
};